/* Akari UGC story carousel + sound-on lightbox. Paired with snippets/akari-video-stories.liquid. */
(function () {
  if (window.__akariStories) return;
  window.__akariStories = true;

  function init() {
    var root = document.querySelector('[data-akari-stories]');
    var lightbox = document.querySelector('[data-akari-lightbox]');
    if (!root || !lightbox) return;

    // Escape any transformed/sticky ancestor so position:fixed is viewport-relative.
    if (lightbox.parentNode !== document.body) document.body.appendChild(lightbox);

    var video = lightbox.querySelector('[data-akari-video]');
    var viewer = lightbox.querySelector('.akari-stories__viewer');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-akari-story]'));
    var sources = cards.map(function (c) { return c.getAttribute('data-video'); });
    var current = -1;

    function play() {
      video.muted = false; // clips carry a voiceover -> play with sound
      var p = video.play();
      if (p && p.catch) p.catch(function () {
        // A browser may refuse sound-on playback if it doesn't count the
        // open/next tap as a direct gesture on the media element. Fall back to
        // muted so the clip still plays rather than showing a black frame.
        video.muted = true;
        var p2 = video.play();
        if (p2 && p2.catch) p2.catch(function () {});
      });
    }

    function load(i) {
      if (!sources.length) return;
      if (i < 0) i = sources.length - 1;
      if (i >= sources.length) i = 0;
      current = i;
      video.src = sources[i];
      video.currentTime = 0;
      play();
    }

    function open(i) {
      lightbox.hidden = false;
      document.body.classList.add('akari-stories-open');
      load(i);
    }

    function close() {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      video.load();
      lightbox.hidden = true;
      document.body.classList.remove('akari-stories-open');
      current = -1;
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { open(i); });
    });

    lightbox.querySelectorAll('[data-akari-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    // Tap empty space around the video closes too.
    if (viewer) viewer.addEventListener('click', function (e) { if (e.target === viewer) close(); });

    var nextBtn = lightbox.querySelector('[data-akari-next]');
    var prevBtn = lightbox.querySelector('[data-akari-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { load(current + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { load(current - 1); });

    // Tap the video itself to pause/resume (no native controls; sound is on).
    video.addEventListener('click', function () {
      if (video.paused) play(); else video.pause();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') load(current + 1);   // RTL: left = next
      else if (e.key === 'ArrowRight') load(current - 1);  // RTL: right = prev
    });

    // Desktop rail arrows, with wrap-around at both ends.
    // Position is taken as abs(scrollLeft) so the math is identical in LTR and RTL
    // (modern browsers report negative scrollLeft in RTL).
    var rail = root.querySelector('.akari-stories__rail');
    var prevRail = root.querySelector('[data-akari-rail-prev]');
    var nextRail = root.querySelector('[data-akari-rail-next]');
    var rtl = rail && getComputedStyle(rail).direction === 'rtl';
    function railStep() {
      var item = rail && rail.querySelector('.akari-stories__item');
      return (item ? item.offsetWidth + 10 : 120) * 2;
    }
    function railMax() { return Math.max(0, rail.scrollWidth - rail.clientWidth); }
    function railPos() { return Math.abs(rail.scrollLeft); }
    function railTo(p) {
      var max = railMax();
      if (p > max) p = 0;          // past the end -> back to first
      else if (p < 0) p = max;     // before the start -> jump to last
      rail.scrollTo({ left: rtl ? -p : p, behavior: 'smooth' });
    }
    function advance() {           // toward later items
      var p = railPos();
      railTo(p >= railMax() - 1 ? 0 : p + railStep());
    }
    function rewind() {            // toward earlier items
      var p = railPos();
      railTo(p <= 1 ? railMax() : p - railStep());
    }
    if (rail && nextRail) nextRail.addEventListener('click', advance);
    if (rail && prevRail) prevRail.addEventListener('click', rewind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
